import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import image from "../logos/nodata.png";
import "./CommonDashboard.css";
import {  useState } from "react";

import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import { useSelector, useDispatch } from "react-redux";


import { CssBaseline } from "@material-ui/core";
import Table from "@material-ui/core/Table";


const theme = createMuiTheme({
  spacing: 2,
  typography: {
    fontSize: 12,
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.75rem",
      color: "rgba(0, 0, 0, 0.87)",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(3)}px)`,
    overFlow: "hidden",
  },
}));

const EMMS = () => {
  const [rows, setRows] = React.useState([]);
  const classes = useStyles();
  const emmsdata = useSelector((state) => state.emms);
  const columns = [
    { field: "name", headerName: "Name", flex: 1, minWidth: 100 },
    { field: "ipAddress", headerName: "IP address", flex: 2, minWidth: 300 },
    {
      field: "portNumber",
      headerName: "Port Number",
      type: "number",
      flex: 1,
      minWidth: 100
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 100
    },
  ];

  React.useEffect(() => {
    if (emmsdata.emms) setRows(emmsdata.emms);
  }, [emmsdata.emms]);

  return (
    <>
      {rows?.length > 0 ? (
        <CssBaseline>
          <ThemeProvider theme={theme}>
            <Table classes={classes.table}>
              <div className="emms-data-grid-container" >
                <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5]}
                  checkboxSelection
                  disableRowSelectionOnClick
                  sx={{ maxWidth: "100vw" }}
                />
              </div>
            </Table>
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <div className="error-container">
          <div className="error">
            <img className="img1" src={image} alt="" />
          </div>
        </div>
      )}
    </>
  );
};

export default EMMS;
